import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'app-state-control',
  templateUrl: './state-control.component.html',
  styleUrls: ['./state-control.component.scss']
})
export class StateControlComponent implements OnInit {

  @Input() color: string;
  constructor() { }

  ngOnInit() {

  }
}
